import * as L from './leaflet.js';
import placImage from "./plac.webp";
import logo from "./../images/logo.svg";
import markerIcon from "./marker-icon.svg";

function initGeoMap() {
    const pos = [51.6148345, 15.3223284];

    const contact = L.map('map-static', {
        // zoomControl: false,
        attributionControl: false,
    }).setView(pos, 17);

    L.tileLayer('{z}/{x}/{y}.webp', {
        minZoom: 14,
        maxZoom: 17,
        noWrap: true,
        attribution: '',
    }).addTo(contact);

    contact.scrollWheelZoom.disable();
    contact.dragging.disable();
    contact.touchZoom.disable();
    var marker = L.marker(pos, {
        icon: L.icon({
            iconUrl: markerIcon,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [0, -41]
        })
    }).addTo(contact);
    marker.bindPopup('<strong>Profesjonalna Szkoła Jazdy Delta</strong></br>Bracka 14/2, 68-100 Żagań<br> <a href="https://g.page/deltazagan" target="_blank"><i>Pokaż na mapie Google </i></a>', {
        closeButton: false
    }).openPopup();
    var bounds = new L.LatLngBounds(new L.LatLng(51.62045, 15.30971), new L.LatLng(51.61141, 15.33794));
    contact.setMaxBounds(bounds);
    contact.on('focus', function () {
        contact.dragging.enable();
    })
    contact.on('blur', function () {
        contact.dragging.disable();
    });
    document.getElementById('map-static').classList.remove('map-static-image');
}

function initStaticMap() {
    document.getElementById('drive-map').innerText = '';

    const driveMap = new L.map('drive-map', {
        crs: L.CRS.Simple,
        minZoom: -4,
        maxZoom: 0,
        zoomSnap: 0.5,
        noWrap: true
    })
    driveMap.scrollWheelZoom.disable();
    var mapBounds = [[0, 0], [5077, 8374]];
    L.imageOverlay(placImage, mapBounds).addTo(driveMap);
    driveMap.fitBounds(mapBounds)
    driveMap.setMaxBounds(mapBounds);
    const driveMarker = L.marker([2998.6405291160063, 5070], {
        icon: L.icon({
            iconUrl: logo,
            iconSize: [70, 28],
            iconAnchor: [35, 14],
            popupAnchor: [0, -14]
        })
    }).addTo(driveMap);
    driveMarker.bindPopup('<strong>Plac manewrowy - Szkoła Jazdy</strong></br>Współrzędne: 51.6273 15.4102<br> <a href="https://goo.gl/maps/8sGHxJ3aMAYH2bLb7" target="_blank"><i>Pokaż na mapie Gogle </i></a>', {
        closeButton: false
    }).openPopup();
    driveMarker.dragging.disable();

    driveMarker.on('focus', function () {
        driveMarker.dragging.enable();
    })
    driveMarker.on('blur', function () {
        driveMarker.dragging.disable();
    });
}


initGeoMap();
initStaticMap();